import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class CustomerSectorService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/CustomerSectors`);
    }

    public readAllForLookup(includeClosed?: boolean): Promise<IEntity[]> {
        return this.readAll();
    }
}